import { postApiRailsServer, getApiRailsServer, getApiGalaxyServer } from 'services';
import { SignInType, ExchangeTokenSuccessResponse, FetchTempTokenSuccessResponse } from 'types';
import { User } from 'AuthModule/reducers';

/**
 * Response from /auth/login endpoint
 */
export type SignInResponse = User & {
  is_super_admin: boolean;
};

/**
 * Response from /rails_api/me endpoint with tenant information
 */
export type GetMeGalaxyResponse = {
  tenant: string;
  tenantInfo: {
    id: string;
    name: string;
    [key: string]: unknown;
  };
};

export const signIn = (credentials: SignInType, config: ApiConfig = {}) =>
  postApiRailsServer<SignInType, SignInResponse>('/auth/login', credentials, config);

export const getAuthToken = (tempToken: string, config: ApiConfig = {}) =>
  getApiRailsServer<ExchangeTokenSuccessResponse>('/auth/get_auth_token', config, tempToken, true);

export const getMeRails = (token: string, config: ApiConfig = {}) =>
  getApiRailsServer<User>('/me', config, token);

export const getMeGalaxy = (token: string, config: ApiConfig = {}) =>
  getApiGalaxyServer<GetMeGalaxyResponse>('/rails_api/me', config, token);

export const getTempToken = (auth_token: string, config: ApiConfig = {}) =>
  getApiRailsServer<FetchTempTokenSuccessResponse>(
    `/auth/get_temp_token`,
    config,
    auth_token,
    true,
  );
